var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "#323130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26034 0.200408C5.56387 0.48226 5.58145 0.956809 5.29959 1.26034L1.77348 5L5.29959 8.73967C5.58145 9.0432 5.56387 9.51775 5.26034 9.7996C4.9568 10.0815 4.48226 10.0639 4.2004 9.76034L0.200405 5.51034C-0.0668016 5.22258 -0.0668016 4.77743 0.200405 4.48966L4.20041 0.239665C4.48226 -0.0638681 4.95681 -0.081444 5.26034 0.200408Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.9c14d75dbea9fdd96c798d1ee9992044.svg";
export { ForwardRef as ReactComponent };